import { render } from "./InternationalTransport.vue?vue&type=template&id=5e8f5a1a&scoped=true"
import script from "./InternationalTransport.vue?vue&type=script&lang=js"
export * from "./InternationalTransport.vue?vue&type=script&lang=js"

import "./InternationalTransport.vue?vue&type=style&index=0&id=5e8f5a1a&scoped=true&lang=scss"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8f5a1a"]])

export default __exports__